import { render } from "./sidebar-get-in-touch.vue?vue&type=template&id=54727ed1"
import script from "./sidebar-get-in-touch.vue?vue&type=script&lang=js"
export * from "./sidebar-get-in-touch.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__